import './index.css';

document.addEventListener('wpcf7mailsent', (event) => {
	const form = event.target;
	const block = form?.closest?.('.obp-contact-form');
	const thankYou = block?.querySelector?.('.obp-contact-form__thank-you');

	if (!thankYou) {
		return;
	}

	form.hidden = true;
	thankYou.hidden = false;
	thankYou.focus?.();
});
